import { type ReactNode } from 'react';
import { FixedBottomFooter } from './FixedBottomFooter';

/**
 * MobileCTAFooter Props
 */
export interface MobileCTAFooterProps {
  /** CTA 버튼 컨텐츠 */
  children: ReactNode;
  /** 푸터 위에 표시할 플로팅 텍스트 (선택사항) */
  floatingText?: ReactNode;
}

/**
 * MobileCTAFooter - 모바일 전용 고정 하단 CTA 래퍼
 *
 * @description
 * 모바일에서만 화면 하단에 고정되는 CTA 버튼 컨테이너입니다.
 * 태블릿 이상(tablet-sm)에서는 숨겨집니다.
 *
 * Features:
 * - 뷰포트 하단에 고정 위치 (FixedBottomFooter 사용)
 * - 상단 테두리가 있는 흰색 배경
 * - 모바일 기기용 안전 영역 패딩
 * - tablet-sm 이상에서 숨김
 * - 푸터 위의 선택적 플로팅 텍스트 (translate 사용)
 *
 * 원래 `pages/quiz/[id]/features/cta-buttons/components` 에 있었다. 폴더 상세가
 * 같은 하단 CTA 를 쓰게 되면서 승격했다 — 두 상세 화면이 데스크톱에서 aside 를 쓰고
 * 모바일에서 이 푸터로 바꾸는 **같은 구성**이다.
 *
 * @example
 * ```tsx
 * <MobileCTAFooter>
 *   <MobileGuestCTAButtons onCopy={handleCopy} onEnter={handleEnter} />
 * </MobileCTAFooter>
 * ```
 */
export const MobileCTAFooter = ({
  children,
  floatingText
}: MobileCTAFooterProps) => {
  return <FixedBottomFooter className="border-t border-alternative bg-white px-md py-xs shadow-lg tablet-sm:hidden" data-sentry-element="FixedBottomFooter" data-sentry-component="MobileCTAFooter" data-sentry-source-file="MobileCTAFooter.tsx">
      {/* 푸터 위의 플로팅 텍스트 (translate를 사용한 absolute 위치) */}
      {!!floatingText && <div className="absolute left-1/2 -translate-x-1/2 -translate-y-[calc(100%+12px)]" data-component="floating-text-wrapper">
          {floatingText}
        </div>}
      {children}
    </FixedBottomFooter>;
};